import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { collectAndSendHeaderReport } from '@paymenttools/hcd-client';

import './i18n';
import './index.scss';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { getEnv } from './utils';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// HCD service is not yet available on every environment - gated by runtime config from /env.
getEnv()
  .then((env) => {
    if (env.hcdReportsEnabled) {
      collectAndSendHeaderReport({ endpoint: env.hcdReportsUrl });
    }
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error('[hcd-client] Failed to load env config:', error);
  });
